import { Stack, Typography } from "@mui/material";
import { SettingsIcon } from "../../images";
import { ManageSectionsBtn } from "../../ui/buttons";
import { useAppSelector } from "../../../hooks";
import { selectPermissions } from "../../../features/permissionsSlice";
import { ReuseButton } from "../../ui";

export const CustomizeDocumentationBlock = ({
  campaign_id,
}: {
  campaign_id: string;
}) => {
  const { isAllowedEditGenerateReports } = useAppSelector(selectPermissions);

  if (!isAllowedEditGenerateReports) return null;

  return (
    <Stack
      sx={{
        width: "100%",
        padding: "24px 16px",
        gap: "16px",
        borderRadius: "6px",
        boxShadow: "0 4px 15.8px 0 #0000001A",
      }}
    >
      <Stack gap={"24px"}>
        <Stack gap={"8px"}>
          <Typography
            color="custom.textDarkBlue"
            variant="subtitle1"
            sx={{
              fontWeight: "600",
            }}
          >
            Customize Documentation
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Define sections to be present in the generated documentation on the
            campaign level.
          </Typography>
        </Stack>
        <ManageSectionsBtn
          campaign_id={campaign_id}
          customButton={(onClick) => (
            <ReuseButton
              onClick={onClick}
              disabled={!isAllowedEditGenerateReports}
              startIcon={<SettingsIcon />}
            >
              Manage Sections
            </ReuseButton>
          )}
        />
      </Stack>
    </Stack>
  );
};
